//store representing customers
//should track who is logged in currently and wrap google_auth library (or composable?)
//Logic for logging in:
//1. call google login:
// 1.A make a random state value with crypto library
// 1.B call google login with state value, recieve a token and validate state value hasn't changed. token stored in localstorage
//2. call google api with token to get basic user information (and allowed scopes checking?)
//3. login to back end with user email, looked up from database
//4. return affirmation of login and apply access rights based on user group
// logging out:
//1. user store logout() should set logged out state (user = null or something) and clear localstorage of token info

import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useStoreSyncer } from '@/composables/Store-syncer';
import router from '@/router'
import axios from '@/libs/axios'

//const devmode = process.env.NODE_ENV === 'development' ? true : false;
const devmode = false;


/**
 * Helper function to get cookie from browser
 * @param cname {string} The cookie (key) name
 * @returns {Object} The cookie
 */
function getCookie(cname: string) {
  console.log('document.cookie = ' + document.cookie)
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  console.log('...decoded cookie = ' + decodedCookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return null
}

/**
 * helper function to nav on auth callback
 */
function navigate(url: string) {
  window.location.href = url
}



/**
 * User Store
 */
export const useUserStore = defineStore('users', () => {
  const { fetchAll, update, remove, create, allItems, loading, error } = useStoreSyncer('/users', 'users'); 
  const allUsers = computed(()=>{
    return allItems.value;
  })
  const currentUser = ref<string | null>('');
  const currentEmail = ref<string | null>('')
  const currentInitials = ref<string | null>('');
  const currentGroup = ref<string | null>('');

  if(devmode === true){
    currentUser.value = 'chris';
    currentEmail.value = 'chris@smpwork.com';
    currentInitials.value = 'CGDEV';
    currentGroup.value = 'admin';

  }else{
    currentUser.value = getCookie('username') //this needs to be null for being logged out
    console.log('user store currentUser = ' + JSON.stringify(currentUser.value))
    currentEmail.value = getCookie('email')
    currentInitials.value = getCookie('initials')
    currentGroup.value = getCookie('group')

  }
//added to api users table:
/*
  const employees = ref([
    { email : 'chris@smpwork.com', name : 'Chris Goodyear', initials : 'CG', title : 'Engineer', group : 'admin'},
    { email : 'steve@smpwork.com', name : 'Steve Petrovich', initials : 'SP', title : 'Engineer', group : 'standard'},
    { email : 'pat@smpwork.com', name : 'Patrick Raina', intitials : 'PR', title : 'Engineer', group : 'standard'},
    { email : 'roger@smpwork.com', name : 'Roger Peng', initials : 'RP', title : 'Engineer', archived : true, group : 'limited'},
    { email : 'brandon@smpwork.com', name : 'Brandon Jodoin', initials : 'BJ', title : 'EIT', group : 'standard'},
    { email : 'negar@smpwork.com', name : 'Negar Kalbodi', initials : 'NK', title : 'Drafter', archived : true, group : 'limited'},
    { email : 'dhan@smpwork.com', name : 'Dhan Perds', initials : 'DP', title : 'Drafter', group : 'limited'},
    { email : 'just@smpwork.com', name : 'Just Bernel', initials : 'JB', title : 'Drafter', group : 'limited'},
    { email : 'janaka@smpwork.com', name : 'Janaka Desaram', initials : 'JD', title : 'Engineer', group : 'standard'}
  ])*/

  const ownerOptions = computed(()=>{
    return allUsers.value.filter(employee =>{
      return (employee.title ==='Engineer' || employee.title === 'EIT')
    }).map(filtered =>{
      return filtered
    })
  })

  const engOptions = computed(()=>{
    return allUsers.value.filter(employee =>{
      return (employee.title ==='Engineer')
    }).map(filtered =>{
      return filtered
    })
  })

  const drafterOptions = computed(()=>{
    return allUsers.value.filter(employee =>{
      return (employee.title ==='Drafter')
    }).map(filtered =>{
      return filtered
    })
  })

/*const ownerOptions = [
  'chris@smpwork.com',
  'steve@smpwork.com',
  'pat@smpwork.com',
  //'roger@smpwork.com',
  'brandon@smpwork.com',
  'janaka@smpwork.com'
]*/
/*
//user options are here:
const engOptions = [
  'chris@smpwork.com',
  'steve@smpwork.com',
  'pat@smpwork.com',
  'roger@smpwork.com',
  'brandon@smpwork.com',
  'janaka@smpwork.com'
]*/
/*
const drafterOptions = [
  //'negar@smpwork.com',
  'neil@smpwork.com',
  'dhan@smpwork.com',
  'just@smpwork.com',
  'other'
]*/

  
  /**
   * Sign in with google, this will add the token and state to the localstorage
   * Alternatively use backend api
   * @returns
   */
  async function signInWithGoogle() {
    await axios
      .post(`/auth/start`)
      .then(function (response) {
        const authUrl = response.data.data.authorizationUrl
        console.log('auth/start returns authUrl = ' + authUrl)
        navigate(authUrl)
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  /**
   * Validate if user is logged in / authenticated based on the 'username' cookie being present
   * @returns Boolean
   */
  function isAuthenticated() {
    try {
      if (currentUser.value && currentUser.value!='') {
        return true
      } else {
        return false
      }
    } catch (error) {
      console.log("customer store can't find user cookie in browser...")
      return false
    }
  }

  /**
   *  logout of backend, cookies are handled by backend only
   */
  async function logout() {
    console.log('users store logging out ' + JSON.stringify(currentUser.value))
    //document.cookie = 'username=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    //document.cookie = 'initials=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
   // document.cookie = 'hasRefreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
   // document.cookie = 'email=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
   // document.cookie = 'group=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    currentUser.value = null
    // router.push('/login');
    await axios
      .post(`/auth/logout`)
      .then(function (response) {
        const message = response.data
        console.log('/auth/logout returns' + JSON.stringify(message))
        //navigate(authUrl);
      })
      .catch(function (error) {
        console.log(error)
      })
    router.push('/login')
  }

/**
 *
 * @param email
 * @returns {String}
 */
function getInitials(email: string) {
  console.log("user-store.getInitials = " + email);
  const found = allUsers.value.find(user =>{
   // console.log("....allUsers email : ", user.email, " matching fo email :", email)
    return (user.email === email);
  })
  return found.initials;
  
}

/**
 *
 * @param id {Number}
 * @returns {String}
 * TODO this should only return basic info name, title, email, initials etc
 */
function getById(id : number) {
  console.log("user-store.getById = " + id);
  const found = allUsers.value.find(user =>{
   // console.log("....allUsers email : ", user.email, " matching fo email :", email)
    return (user.id === id);
  })
  console.log("found user : " + JSON.stringify(found));
  return found;
  
}

function getByEmail(email: string) {
  console.log("user-store.getByEmail = " + email);
  const found = allUsers.value.find(user =>{
   // console.log("....allUsers email : ", user.email, " matching fo email :", email)
    return (user.email === email);
  })
  return found;
  
}



  //User store exports
  return {
    currentUser,
    currentEmail,
    currentInitials,
    currentGroup,
    signInWithGoogle,
    isAuthenticated,
    logout,
    getInitials,
    engOptions,
    drafterOptions,
    ownerOptions,
    allUsers,
    getById,
    getByEmail
  }
})

